import { render } from "./TeacherLeaveDetailView.vue?vue&type=template&id=4d45584c&scoped=true"
import script from "./TeacherLeaveDetailView.vue?vue&type=script&lang=js"
export * from "./TeacherLeaveDetailView.vue?vue&type=script&lang=js"

import "./TeacherLeaveDetailView.vue?vue&type=style&index=0&id=4d45584c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d45584c"]])

export default __exports__